import { Buffer } from 'node:buffer';
import { getEncoding } from 'istextorbinary';

export function isBinaryFile(buffer: Uint8Array | undefined) {
  if (buffer === undefined) {
    return false;
  }

  const nodeBuffer = Buffer.from(buffer.buffer, buffer.byteOffset, buffer.byteLength);

  return getEncoding(nodeBuffer, { chunkLength: 100 }) === 'binary';
}
